<template>
  <div class="content">
    <div class="title">
      <p class="title-text">Change Artist Subscription</p>
      <p class="subtitle">
        Upgrade or downgrade your plan.
      </p>
    </div>
    <div class="billing-card">
      <div class="card-top">
        <span class="card-title">Confirm change</span>
        <p class="card-text">
          We'll adjusts the price based on how many days are left in the billing
          cycle, and charge the newly-calculated rate immediately for upgrades.
        </p>
      </div>
      <div class="card-content">
        <div v-if="authorization.length" class="braintree-billing">
          <template>
            <v-braintree
              :card="{
                cvv: {
                  required: true
                },
                overrides: {
                  styles: {
                    input: {
                      color: 'white'
                    },
                    ':focus': {
                      color: 'white'
                    }
                  }
                }
              }"
              :vaultManager="true"
              :authorization="authorization"
              @load="onLoad"
              @success="onSuccessBillingUpdate"
              @error="onError"
            >
              <template v-slot:button="slotProps">
                <div class="payment-footer">
                  <div class="total">
                    <span class="text">Switch to</span>
                    <span v-if="isLitePlan" class="value">Pro plan</span>
                    <span v-else class="value">Lite plan</span>
                  </div>
                  <button
                    @click="slotProps.submit"
                    class="button-default big"
                    :disabled="saving || !braintreeInstance"
                  >
                    <span>Confirm</span>
                  </button>
                </div>
              </template>
            </v-braintree>
          </template>
        </div>
      </div>
    </div>
    <SnackBar />
  </div>
</template>

<script>
import {
  M_BRAINTREE_CLIENT_TOKEN,
  M_CHANGE_ARTIST_SUBSCRIPTION
} from "@/graphql";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "ChangeSubscription",
  components: {
    SnackBar
  },
  data() {
    return {
      authorization: "",
      braintreeInstance: null,
      saving: false
    };
  },
  apollo: {},
  async created() {
    const result = await this.$apollo.mutate({
      client: "localClient",
      mutation: M_BRAINTREE_CLIENT_TOKEN
    });
    this.authorization = result.data.braintree_client_token.token;
  },
  filters: {
    date(val) {
      return new Date(val).toLocaleDateString();
    },
    price(val) {
      if (val) {
        return val.toFixed(2);
      } else {
        return 0;
      }
    }
  },
  watch: {
    artist: async function(newArtist, oldArtist) {
      console.log({ newArtist, oldArtist });
      if (
        newArtist.braintree_subscription_status &&
        this.subscriptionActive(newArtist)
      ) {
        await this.$router.push({ name: "ArtistSettings" });
      }
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isLitePlan() {
      return !!(this.artist.plan && this.artist.plan.includes("lite"));
    },
    isProPlan() {
      return !!(
        this.artist.plan &&
        (this.artist.plan.includes("base") || this.artist.plan.includes("pro"))
      );
    },
    snack() {
      return this.$store.getters.getSnack;
    },
    billingTotal() {
      return this.artist.monthly_charge;
    }
  },
  methods: {
    onLoad(instance) {
      this.braintreeInstance = instance;
    },
    async onSuccessBillingUpdate(payload) {
      let nonce = payload.nonce;
      // Do something great with the nonce...
      console.log(payload);

      const subscription_id = this.artist.braintree_subscription_id;
      console.log(subscription_id);

      try {
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_CHANGE_ARTIST_SUBSCRIPTION,
          variables: {
            artist_id: this.artist.id,
            braintree_nonce: nonce,
            plan: this.isProPlan ? 'base' : 'lite'
          }
        });
        console.log("M_CHANGE_ARTIST_SUBSCRIPTION", response);
        const { success } = response.data.braintree_change_subscription;
        if (success) {
          return this.$router.push({ name: "ArtistSettings" });
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      }
    },
    onError(error) {
      // let message = error.message;
      console.log("onerror", error);
      // Whoops, an error has occurred while trying to get the nonce
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  background: #1b193c;
  display: flex;
  flex-direction: column;
  padding: 36px 60px;
}
.title {
  .title-text {
    margin: 0;
    padding-bottom: 6px;
    font-weight: bold;
    font-size: 30px;
    line-height: 37px;
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .subtitle {
    margin: 0;
    padding-bottom: 36px;
    /* 16/Regular */
    font-size: 16px;
    line-height: 24px;
    /* Text/type2 */
    color: #59588d;
  }
}
.billing-card {
  display: grid;
  grid-gap: 24px;
  margin-top: 36px;
  padding: 24px;
  /* BG/type2 */
  background: #24224a;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: #ffffff;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: #b1afcd;
      mix-blend-mode: normal;
      opacity: 0.9;
      .bold {
        font-weight: 600;
        //color: white;
      }
    }
  }
  .card-content {
    display: grid;
    grid-gap: 24px;
    .payment-footer {
      display: flex;
      .button-text {
        width: 120px;
      }
      .total {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        margin-right: 24px;
        .text {
          /* 14/Regular */
          font-size: 14px;
          line-height: 18px;
          text-align: right;
          /* Text/type0 */
          color: $text-type-0;
        }
        .value {
          /* 16/SemiBold */
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          text-align: right;
          /* White */
          color: white;
        }
      }
      .button-default {
        width: 155px;
      }
    }
    .braintree-billing {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .payment {
        width: 100%;
        .button-default {
          //margin-top: -44px;
          padding: 9px 30px;
          float: right;
        }
      }
    }
  }
}
</style>
